module.exports = __webpack_public_path__ + "img/album21_12.c738552a.jpg";